import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { Observable } from 'rxjs';

import { Status } from '../../../../core/ronex/_models/status.model';
import { ShipmentService } from '../../../../core/ronex/_services/shipment.service';

@Component({
  selector: 'kt-shipment-view-bs',
  templateUrl: './shipment-view-bs.component.html',
  styleUrls: ['./shipment-view-bs.component.scss'],
})
export class ShipmentViewBsComponent implements OnInit {
  _cs = false;
  _status: Observable<Status[]>;

  constructor(
    public bsRef: MatBottomSheetRef<ShipmentViewBsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private ss: ShipmentService
  ) {}

  ngOnInit() {
    if (!this.data.financial) {
      this._cs = this.data.item.courier == 'COURIER_CENTER';
      this._status = this.ss.getStatus(this.data.item);
    }
  }

  close() {
    this.bsRef.dismiss();
  }
}
